import { User } from '@botpress/webchat-client'
import { create } from 'zustand'

type ParticipantStore = {
  participants: User[]
  setParticipants: (participants: User[]) => void
  addParticipant: (participant: User) => void
  removeParticipant: (participantId: string) => void
  clearParticipants: () => void
}

export const useParticipantStore = create<ParticipantStore>()((set) => ({
  participants: [],
  setParticipants: (participants: User[]) => set({ participants }),
  addParticipant: (participant: User) => set((state) => ({ participants: [...state.participants, participant] })),
  removeParticipant: (participantId: string) =>
    set((state) => ({ participants: state.participants.filter((p) => p.id !== participantId) })),
  clearParticipants: () => set({ participants: [] }),
}))
